import {createSvgIcon} from './utils'

export default createSvgIcon(
  <svg fill="none" height="25" viewBox="0 0 24 25" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9827 0.79495L4.69562 3.63043V4.67391H18.2608V1.81171C18.2608 1.14066 17.6366 0.644059 16.9827 0.79495Z"
      fill="#21201F"
      opacity="0.4"
    />
    <circle cx="12" cy="12.5" fill="#21201F" opacity="0.4" r="3.65217" />
    <path
      clip-rule="evenodd"
      d="M8.86924 20.3225C8.5812 20.3224 8.34778 20.0888 8.34778 19.8008V18.7609C8.34778 18.4727 8.58137 18.2391 8.86952 18.2391H15.1304C15.4185 18.2391 15.6521 18.4727 15.6521 18.7609V19.8041C15.6521 20.0923 15.4184 20.326 15.1301 20.3258L8.86924 20.3225Z"
      fill="#21201F"
      fill-rule="evenodd"
    />
    <path
      d="M4.69558 4.67391L19.3043 4.67391L19.3043 23.4565L4.69558 23.4565L4.69558 4.67391Z"
      stroke="#21201F"
      stroke-width="2.08696"
    />
  </svg>,
  'PassportIcon',
)
